import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.css']
})
export class RecordsComponent {
  constructor(private location: Location, private appComponent:AppComponent) {
    this.appComponent.route.subscribe((route)=>{
      this.isActive = (route == "/control-ingreso/registro") ? true : false;
    });
  }
  isActive: boolean=false;
  ngOnInit(): void {
    const currentPath = this.location.path();
    this.isActive = (currentPath === "/control-ingreso/registro") ? true : false;
  }
}
